export const helperMixin = {
    methods: {
        capitalizeFirstLetter(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        },
        formatDate(inputDate) {
            const parsedDate = new Date(inputDate);
            if (isNaN(parsedDate.getTime())) {
                return inputDate;
            }
            const day = parsedDate
                .getDate()
                .toString()
                .padStart(2, "0");
            const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
            const year = parsedDate.getFullYear();
            return `${day}.${month}.${year}`;
        },
        formatTime(dateTimeString) {
            const parsedDate = new Date(dateTimeString);
            if (isNaN(parsedDate.getTime())) {
                return dateTimeString;
            }
            const hours = parsedDate.getHours().toString().padStart(2, "0");
            const minutes = parsedDate.getMinutes().toString().padStart(2, "0");
            return `${hours}:${minutes}`;
        },
        getName(value) {
            if (!value) {
                return "-";
            }

            if (typeof value === "object" && value.name) {
                return value.name;
            } else if (typeof value === "string") {
                return value;
            }

            return value;
        },
    }
};
